import { EnsoRing, BeltStrip } from "@/components/karate";

export function PageHeader({ eyebrow, title, subtitle, kanji = "空手道" }) {
  return (
    <div className="relative overflow-hidden border-b border-slate-200 bg-white">
      <div className="pointer-events-none absolute inset-0 kagome opacity-70" />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-ukf-gold/40 to-transparent" />
      <span aria-hidden="true" className="pointer-events-none absolute right-4 top-1/2 hidden -translate-y-1/2 select-none font-serif leading-none text-slate-900/[0.045] text-[9rem] sm:block lg:right-12">{kanji}</span>
      <div className="relative mx-auto max-w-7xl px-4 py-14 sm:px-6 md:py-20 lg:px-8">
        {eyebrow && (
          <p className="mb-4 flex items-center gap-3 font-mono text-xs font-semibold uppercase tracking-[0.22em] text-ukf-red">
            <span className="h-px w-8 bg-ukf-gold" /> {eyebrow}
          </p>
        )}
        <h1 className="pt-10 font-serif text-3xl font-bold leading-[1.3] tracking-tight text-ukf-ink sm:pt-12 sm:text-5xl">{title}</h1>
        <div className="ukf-gold-rule mt-5" />
        {subtitle && <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-600">{subtitle}</p>}
      </div>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, message, testid, kanji }) {
  return (
    <div
      data-testid={testid}
      className="relative mx-auto my-8 max-w-2xl overflow-hidden rounded-2xl border border-dashed border-slate-300 bg-white/80 px-6 py-16 text-center shadow-inner"
    >
      <div className="pointer-events-none absolute inset-0 kagome opacity-50" />
      <div className="relative mx-auto mb-5 flex h-20 w-20 items-center justify-center">
        <EnsoRing className="absolute inset-0 h-full w-full opacity-70" stroke="#C9A24B" strokeWidth={4} />
        {kanji ? (
          <span className="font-serif text-2xl font-semibold text-ukf-red">{kanji}</span>
        ) : Icon ? (
          <Icon className="h-7 w-7 text-ukf-red" />
        ) : null}
      </div>
      <h3 className="relative font-serif text-xl font-bold text-slate-800">{title}</h3>
      {message && <p className="relative mx-auto mt-2 max-w-md text-sm text-slate-500">{message}</p>}
      <BeltStrip className="absolute inset-x-0 bottom-0 h-1" />
    </div>
  );
}

export function Loader({ label = "Loading…" }) {
  return (
    <div className="flex items-center justify-center py-24 text-slate-400" data-testid="loader">
      <div className="h-6 w-6 animate-spin rounded-full border-2 border-slate-200 border-t-ukf-red" />
      <span className="ml-3 text-sm">{label}</span>
    </div>
  );
}
